export default "__VITE_ASSET__ac353fee__"